(function() {
  if (window.externalCheckoutModalInit) return;
  window.externalCheckoutModalInit = true;

  function showPrimaryExternalTriggers() {
    document.querySelectorAll('.product-single__form > button[data-external-checkout-trigger]:not(.sticky_add_to_cart)').forEach(function(button) {
      if (button.style.getPropertyValue('display') !== 'flex' || button.style.getPropertyPriority('display') !== 'important') {
        button.style.setProperty('display', 'flex', 'important');
      }

      if (button.style.getPropertyValue('opacity')) {
        button.style.removeProperty('opacity');
      }
    });
  }

  function watchPrimaryExternalTriggers() {
    if (!window.MutationObserver) return;

    document.querySelectorAll('.product-single__form > button[data-external-checkout-trigger]:not(.sticky_add_to_cart)').forEach(function(button) {
      if (button.dataset.externalCheckoutVisibilityWatched) return;

      button.dataset.externalCheckoutVisibilityWatched = 'true';
      new MutationObserver(showPrimaryExternalTriggers).observe(button, {
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    });
  }

  function syncPrimaryExternalTriggers() {
    showPrimaryExternalTriggers();
    watchPrimaryExternalTriggers();
  }

  function findExternalCheckoutTrigger(event) {
    var trigger = event.target.closest('[data-external-checkout-trigger]');
    if (trigger || event.target.closest('[data-external-checkout-modal]')) return trigger;

    var card = event.target.closest('.img-container');
    if (!card) return null;

    return card.querySelector('.whole-card__link[data-external-checkout-trigger]');
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-open');
    document.documentElement.classList.remove('external-checkout-modal-open');
    window.setTimeout(function() {
      modal.hidden = true;
    }, 180);

    var returnFocusTo = modal._externalCheckoutReturnFocus;
    if (returnFocusTo && typeof returnFocusTo.focus === 'function' && document.contains(returnFocusTo)) {
      returnFocusTo.focus();
    }
    modal._externalCheckoutReturnFocus = null;
  }

  document.addEventListener('click', function(event) {
    var trigger = findExternalCheckoutTrigger(event);
    var close = event.target.closest('[data-external-checkout-close]');
    var continueButton = event.target.closest('[data-external-checkout-continue]');

    if (trigger) {
      event.preventDefault();
      var modal = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!modal) return;

      modal.dataset.externalCheckoutUrl = trigger.dataset.externalCheckoutUrl || modal.dataset.externalCheckoutUrl;
      modal._externalCheckoutReturnFocus = trigger;
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      modal.hidden = false;

      requestAnimationFrame(function() {
        modal.classList.add('is-open');
        document.documentElement.classList.add('external-checkout-modal-open');
      });

      var firstButton = modal.querySelector('[data-external-checkout-close]');
      if (firstButton) firstButton.focus();
    }

    if (close) {
      closeModal(close.closest('[data-external-checkout-modal]'));
    }

    if (continueButton) {
      var continueModal = continueButton.closest('[data-external-checkout-modal]');
      var url = continueModal && continueModal.dataset.externalCheckoutUrl;
      if (url) window.location.href = url;
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-external-checkout-modal].is-open').forEach(closeModal);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPrimaryExternalTriggers);
  } else {
    syncPrimaryExternalTriggers();
  }

  window.addEventListener('ppJustLaunched', syncPrimaryExternalTriggers);
})();
